import React, { createContext, useState, useEffect } from 'react';

export const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
    const [userInfo, setUserInfo] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token-techcomp') || sessionStorage.getItem('token-techcomp');

        if (token) {
            const name = localStorage.getItem('user-name') || sessionStorage.getItem('user-name') || '';
            const type = localStorage.getItem('user-type') || sessionStorage.getItem('user-type') || '';

            setUserInfo({
                token,
                name,
                type
            });
        }
    }, []);

    return (
        <UserContext.Provider value={{ userInfo, setUserInfo }}>
            {children}
        </UserContext.Provider>
    );
};
